import { constantTree } from "../../../core/events/ConstantTree";

export const corporateAccountTree = constantTree({
  Request: {
    GetActivity: "",
    GetCities: "",
    GetCountryCode: "",
    Button: {
      Click: ""
    },
    Page: {
      Unmount: ""
    },
    Field: {
      onChange: ""
    },
    FAQ: {
      Get: ""
    },
    FlowStarted: "",
    CustomerContact: {
      Categories: {
        Get: ""
      }
    }
  }
})